<template>
  <material-pagination color="primary">
    <material-pagination-item prev @click="prevPage" :disabled="currentPage === 1" />&nbsp;
    <material-pagination-item
      v-for="page in visiblePages"
      :key="page"
      :label="String(page)"
      :active="page === currentPage"
      @click="changePage(page)"
    />&nbsp;
    <material-pagination-item next @click="nextPage" :disabled="currentPage === totalPages" />
  </material-pagination>
</template>

<script>
import MaterialPagination from "@/components/MaterialPagination.vue"
import MaterialPaginationItem from "@/components/MaterialPaginationItem.vue"

export default {
  name: 'Pagination',
  components: {
    MaterialPagination,
    MaterialPaginationItem
  },
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  emits: ['update:currentPage'],
  computed: {
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      // 10페이지 단위로 표시 (1-10, 11-20, 21-30...)
      const pageGroup = Math.ceil(current / 10);
      const start = (pageGroup - 1) * 10 + 1;
      const end = Math.min(pageGroup * 10, total);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    changePage(page) {
      this.$emit('update:currentPage', page)
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.$emit('update:currentPage', this.currentPage - 1)
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit('update:currentPage', this.currentPage + 1)
      }
    }
  }
}
</script> 